import React from 'react'
import styled from 'styled-components'
import { Modal } from '../../../../../molecules/Modal'

interface ImagePickerModalProps {
  isOpen: boolean
  onClose: () => void
  images: string[]
  onSelectImage: (imageUrl: string) => void
  selectedImages?: string[]
}

const ModalContent = styled.div`
  padding: 24px;
`

const ModalTitle = styled.h3`
  margin: 0 0 20px 0;
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
`

const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  max-height: 400px;
  overflow-y: auto;
`

const ImageItem = styled.div<{ $isSelected?: boolean }>`
  position: relative;
  aspect-ratio: 4/3;
  border-radius: 8px;
  overflow: hidden;
  cursor: pointer;
  border: 3px solid
    ${({ $isSelected }) => ($isSelected ? '#2563eb' : 'transparent')};
  transition: all 0.2s ease;

  &:hover {
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
`

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const SelectedBadge = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  background: #2563eb;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
`

const EmptyState = styled.div`
  text-align: center;
  padding: 40px;
  color: #64748b;
`

export const ImagePickerModal: React.FC<ImagePickerModalProps> = ({
  isOpen,
  onClose,
  images,
  onSelectImage,
  selectedImages = [],
}) => {
  const handleSelect = (imageUrl: string) => {
    onSelectImage(imageUrl)
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose} maxWidth="600px">
      <ModalContent>
        <ModalTitle>Sélectionner une image</ModalTitle>
        {images.length > 0 ? (
          <ImageGrid>
            {images.map((imageUrl, index) => {
              const selectedIndex = selectedImages.indexOf(imageUrl)
              const isSelected = selectedIndex !== -1
              return (
                <ImageItem
                  key={index}
                  $isSelected={isSelected}
                  onClick={() => handleSelect(imageUrl)}
                >
                  <Image src={imageUrl} alt={`Option ${index + 1}`} />
                  {isSelected && (
                    <SelectedBadge>{selectedIndex + 1}</SelectedBadge>
                  )}
                </ImageItem>
              )
            })}
          </ImageGrid>
        ) : (
          <EmptyState>Aucune image disponible</EmptyState>
        )}
      </ModalContent>
    </Modal>
  )
}
